export const SET_MANUFACTURERS_DROPDOWN = '@createProducts/SET_MANUFACTURERS_DROPDOWN';
export const SET_LOADING_MF_OPTIONS = '@createProducts/SET_LOADING_MF_OPTIONS';
export const SET_SUBMIT_LOADING = '@createProducts/SET_SUBMIT_LOADING';
export const SET_PRODUCT_NAME = '@createProducts/SET_PRODUCT_NAME';
export const SET_SELECTED_MF = '@createProducts/SET_SELECTED_MF';
export const SET_STATUS = '@createProducts/SET_STATUS';



// WEBPACK FOOTER //
// ./src/Modules/CreateNewProduct/constants.js